module.exports = __webpack_public_path__ + "img/twitter_logo.15062165.png";